import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { Challenges } from './challenges.type';
import { getChallengesApi } from './challenges.apis';

const initialState: Challenges = {
	loading: false,
	status: '',
	challenges: {
		current: [],
		previous: [],
	},
	themes: [],
};

const getChallenges = createAsyncThunk(
	'challenges/getChallenges',
	async (_, { rejectWithValue, getState }: any) => {
		try {
			const response = await getChallengesApi();
			return response;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);

const formatChallenges = (challenges: any) => {
	const result: any = { current: [], previous: [] };

	for (let i = 0; i < challenges.length; i++) {
		if (challenges[i].current) result.current.push(challenges[i]);
		else result.previous.push(challenges[i]);
	}

	return result;
};

const formatThemes = (challenges: any) => {
	const themes: any = [];
	challenges.forEach((item: any) => {
		if (item.themes.length > 0) {
			item.themes.forEach((data: any, number: number) => {
				themes.push({ ...data, index: number, challengeTitle: item.title });
			});
		}
	});
	return themes;
};

const challengesSlice = createSlice({
	name: 'challenges',
	initialState: initialState,
	reducers: {
		setChallenges: (state, action) => {
			return { ...state, ...action.payload };
		},
		reset: () => initialState,
	},

	extraReducers: (builder) => {
		builder.addCase(getChallenges.pending, (state, action) => {
			state.loading = true;
		});
		builder.addCase(getChallenges.fulfilled, (state, action) => {
			state.loading = false;
			state.status = 'CHALLENGE_FETCHED_SUCCESSFULLY';
			state.challenges = formatChallenges(action.payload?.data);
			state.themes = formatThemes(action.payload?.data);
		});
		builder.addCase(getChallenges.rejected, (state, action) => {
			state.loading = false;
		});
	},
});

export const challengesReducer = challengesSlice.reducer;

export const challengesActions = {
	...challengesSlice.actions,
	getChallenges,
};
